import React from 'react';
import { Link, Navigate } from 'react-router-dom';

import { useAuth } from '../../../contexts/AuthContext';
import LoginAuthForm from '../components/LoginAuthForm';
import LoginHeroSection from '../components/LoginHeroSection';

function Login(): JSX.Element {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/" />;
  }

  return (
    <div className="min-h-screen flex flex-col relative">
      <div className="flex flex-1">
        <LoginHeroSection />
        <LoginAuthForm />
      </div>

      {/* Footer with About Us link */}
      <div className="absolute bottom-0 right-0 w-1/3 py-4 flex justify-center">
        <Link
          to="/about"
          className="text-xs text-[#CE3F4F] font-nunito font-medium hover:underline"
        >
          Learn more about BC Experience
        </Link>
      </div>
    </div>
  );
}

export default Login;
